// extracted by mini-css-extract-plugin
module.exports = {"statusImage":"Dynamics_statusImage__Z8VS2","englishData":"Dynamics_englishData__2G0ks","label":"Dynamics_label__2WBFn","data":"Dynamics_data__pOLLm"};